import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { AssetMaintenanceCycleTypeOptions } from 'src/app/property/constants/asset-maintenance-cycle.enum';
import { AssetModel } from 'src/app/property/models/new-asset.model';
import { FileUploadConfig } from 'src/app/shared/models/file-upload-config.model';
import { Attachment } from 'src/app/shared/models/uploaded-file-list.model';
import { DatePipe } from '@angular/common';
import { AssetResult } from 'src/app/job/models/asset.model';
import { JobAssetService } from 'src/app/core/services/http/maintenance/job-asset.service';
@Component({
  selector: 'app-edit-asset',
  templateUrl: './edit-asset.component.html',
  styleUrls: ['./edit-asset.component.scss']
})
export class EditAssetComponent implements OnInit {

  asset = new AssetModel();
  assetMaintenanceCycleTypeOptions = AssetMaintenanceCycleTypeOptions;
  isSaving = false;
  public config: FileUploadConfig;
  public assetsToCheck:AssetResult[] = [];

  @Input() set assetId(value: string) {
    if (!value)
      return;
    this.asset.id = value;
    this.getAssetDetails(value);
  }

  @Input() set assetDetails(value: AssetModel) {
    if (!value)
      return;
    this.asset = {...value};
    this.SetImageConfig();
  }

  @Output() dismissEditAssetDrawer = new EventEmitter<boolean>();

  constructor(private assetService: AssetService, 
    private tosterService: TosterService, 
    private datePipe: DatePipe,
    private jobAssetService:JobAssetService) { }

  ngOnInit(): void {   
  }

  getAssetDetails(assetId: string) {
    this.assetService.details(assetId).subscribe({
      next: (res) => {
        if (res != null){
          this.asset = {...res};
          this.SetImageConfig();
          this.GetPropertyAssetDetails();
        }
      }
    })
  }


  dismiss(refreshAssetList: boolean = false) {
    this.dismissEditAssetDrawer.emit(refreshAssetList);
  }

  addUploadedAttachments(attachments: Attachment[] = []) {
    this.asset.attachments = attachments.map((element) => ({
      id: element.getId(),
      name: element.name,
      existing: element.existing,
    }));
  }

  GetPropertyAssetDetails(){
    this.assetService.list(this.asset.propertyId).subscribe((data:AssetResult[]) => {
      this.assetsToCheck=data;    
    }); 
  }
  save() {
    this.isSaving = true;
    this.asset.usefulLife = this.asset.usefulLife?this.asset.usefulLife:0;
    this.asset.maintenanceCycle = typeof this.asset.maintenanceCycle === 'undefined' || this.asset.maintenanceCycle === null ? -1 : this.asset.maintenanceCycle;
    this.asset.dateOfPurchase = this.datePipe.transform(this.asset.dateOfPurchase, 'yyyy-MM-dd');
    if(this.assetsToCheck.some(x=>x.name.trim().toLowerCase() === this.asset.name.trim().toLowerCase() && x.id != this.asset.id))
      {
        this.tosterService.error("Same Asset name will exist in the Property. You are not able to add a new Asset with the same Asset Name");
        this.isSaving = false;
        return ;
      }
    this.assetService.edit(this.asset).subscribe({
      next: (res) => {
        this.tosterService.success("Assets details successfully updated!");

        this.jobAssetService.editAssets(this.asset); 
        
        let privourAssetModel = {
          id: this.asset.id,
          assetName: this.asset.name,
          isDuplicated: res.isDuplicated,
          isSucceeded: res.isSucceeded
        }
       
        this.asset = new AssetModel();
        this.isSaving = false;
        this.dismiss(true);
        this.assetService.editedAssetDetails(privourAssetModel);
      },
      error: (err) => {
        this.isSaving = false;
      }
    });
  }

  private SetImageConfig() {
    const config = new FileUploadConfig();
    config.files = this.asset?.attachments?.map((d) => {
      return {
        name: d.name,
        url: d.blobUrl,
        comment: "",
        existing: true,
      };
    });
    config.supportedExtensions = '.jpg, .jpeg, .png, .pdf';
    this.config = config;
  }

  formatCost(value: number | null): string {
    return value != null ? value.toFixed(2) : '';
  }
  
  onCostBlur(event: any) {
    const value = parseFloat(event.target.value);
    this.asset.cost = isNaN(value) ? 0 : value;
  }
  
}
